import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'landed-volume',
    templateUrl: './landed-volume.component.html',
    styleUrl: './landed-volume.component.css',
    standalone: false
})
export class LandedVolumeComponent implements OnInit
{
  @Input() indicators: Array<any>;
  
  public volume: any;
  
  ngOnInit(): void 
  {
    if (this.indicators) {
      let outputs: Array<any> = this.indicators.sort((e1,e2) => {
        if (e1.timeframe < e2.timeframe) {
          return 1;
        } else if (e1.timeframe > e2.timeframe) {
          return -1;
        } else {
          return 0;
        }
      }).filter(item => item.measure?.value.toLowerCase() === 'catch' || item.measure?.value.toLowerCase() === 'landing');

      if (outputs.length > 0) 
      {
        let catches: Array<any> = outputs.filter(item => item.measure?.value.toLowerCase() === 'catch');
        if (catches.length > 0) {
          this.volume = catches[0];
        }
        else
        {
          let landing: Array<any> = outputs.filter(item => item.measure?.value.toLowerCase() === 'landing');
          if (landing.length > 0) {
            this.volume = landing[0];
          }
        }
      }
    }
  }

  format(value)
  {
    return value;
  }
}
